import { render } from "./PrintGuidesSelector.vue?vue&type=template&id=324cd043&scoped=true"
import script from "./PrintGuidesSelector.vue?vue&type=script&lang=js"
export * from "./PrintGuidesSelector.vue?vue&type=script&lang=js"

import "./PrintGuidesSelector.vue?vue&type=style&index=0&id=324cd043&scoped=true&lang=css"

import exportComponent from "/Users/andresrivas/NoSincronizar/Vue/Swift Fulfillment/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-324cd043"]])

export default __exports__